import {
  VuexModule,
  Module,
  Action,
  Mutation,
} from 'vuex-module-decorators';
import Pusher from 'pusher-js';

const sound = require('@/assets/sound/notifysound.mp3');

@Module({ namespaced: true })
export default class Notification extends VuexModule {
  public withdrawRequestCreatedIds: Array<string> = [];

  public depositRequestCreatedIds: Array<string> = [];

  @Mutation
  public updateRequestState(payload: { type: string; data: Array<string> }) {
    if (payload.type === 'deposit') this.depositRequestCreatedIds = [...payload.data];
    if (payload.type === 'withdraw') this.withdrawRequestCreatedIds = [...payload.data];
  }

  @Action
  public async setNotificationDataToLocalStorage(payload: { type: string; data: string }) {
    console.log('new data coming');
    let data: string | null = await sessionStorage.getItem(`${payload.type}-request-data`);
    if (!data) {
      data = JSON.stringify([payload.data]);
    } else {
      const jsonData = JSON.parse(data);
      jsonData.push(payload.data);
      data = JSON.stringify(jsonData);
    }
    await sessionStorage.setItem(`${payload.type}-request-data`, data);
    this.context.commit('updateRequestState', { type: payload.type, data: JSON.parse(data) });
  }

  @Action
  public subscribeNotification() {
    const pusher = new Pusher('c2756f0d9309919e42f6', { cluster: 'ap1' });
    const channel = pusher.subscribe('request-notification');
    channel.bind('deposit-request-created', async (data: string) => {
      await this.context.dispatch('setNotificationDataToLocalStorage', { type: 'deposit', data });
      const notify = new Audio(sound);
      notify.play();
    });
    channel.bind('withdraw-request-created', async (data: string) => {
      await this.context.dispatch('setNotificationDataToLocalStorage', { type: 'withdraw', data });
      const notify = new Audio(sound);
      notify.play();
    });
  }

  @Action
  public async removeRequestState(type: string) {
    await sessionStorage.removeItem(`${type}-request-data`);
    this.context.commit('updateRequestState', { type, data: [] });
  }

  @Action
  public async initiateNotificationState() {
    const depositData = await sessionStorage.getItem('deposit-request-data');
    if (depositData) {
      this.context.commit('updateRequestState', { type: 'deposit', data: JSON.parse(depositData) });
    }
    const withdrawData = await sessionStorage.getItem('withdraw-request-data');
    if (withdrawData) {
      this.context.commit('updateRequestState', { type: 'withdraw', data: JSON.parse(withdrawData) });
    }
  }
}
